import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import CampSessionCreateEditForm from './Components/CampSessionCreateEditForm';
import CampSessionApi from './CampSessionApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: CampSessionCreateEditForm,
                getCreate: CampSessionApi.create,
                defaults: {},
                successMessage: "Camp Session Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}